import {
    trackEvent,
    TRACKING_EVENT,
    type TrackingPage,
} from '@zooplus/tracker-listener';

const COMPONENT_NAME = 'header_navigation_banner';
const TRACKING_PAGE: TrackingPage = 'GLOBAL';

type BannerTrackingParams = {
    categoryType: string | undefined;
    animalType: string | undefined;
    siteId: number;
    locale: string;
    analyticsId?: string | null;
};

function buildBannerTargetId(
    categoryType: string | undefined,
    animalType: string | undefined,
): string {
    if (animalType) {
        return `banner_${animalType.toLowerCase()}`;
    }

    if (animalType === 'OFFERS' || categoryType === 'OFFERS') {
        return `banner_specials`;
    }

    return `banner_root`;
}

export function trackBannerImpression({
    categoryType,
    animalType,
    siteId,
    locale,
    analyticsId,
}: BannerTrackingParams): void {
    trackEvent({
        event: TRACKING_EVENT.IMPRESSION,
        page: TRACKING_PAGE,
        detail: {
            platform: 'WEB',
            locale,
            siteId,
            target: {
                name: COMPONENT_NAME,
                id: buildBannerTargetId(categoryType, animalType),
                ...(analyticsId
                    ? { extra: { contentfulId: analyticsId } }
                    : {}),
            },
        },
    });
}

export function trackBannerClick({
    categoryType,
    animalType,
    siteId,
    locale,
    analyticsId,
}: BannerTrackingParams): void {
    trackEvent({
        event: TRACKING_EVENT.CLICK,
        page: TRACKING_PAGE,
        detail: {
            platform: 'WEB',
            locale,
            siteId,
            target: {
                name: COMPONENT_NAME,
                id: buildBannerTargetId(categoryType, animalType),
                ...(analyticsId
                    ? { extra: { contentfulId: analyticsId } }
                    : {}),
            },
        },
    });
}
